<template>
  <v-card style="padding: 0px 20px">
    <div>
    <v-tabs :value="currentTab" fixed-tabs slider-color="#4fa2b7">
      <v-tab
        disabled
        v-for="(tab, index) in tabs"
        :key="index"
        class="custom-tab"
      >
        {{ tab.label }}
      </v-tab>
    </v-tabs>
    </div>
    <v-card-text class="text-left">
      <div class="textContainer">
        <div v-if="currentTab === 0">{{ $t("CustomMessageWorkspace") }}</div>
        <div v-else-if="currentTab === 1">
          {{ $t("CustomMessageBuildings") }}
        </div>
        <div v-else-if="currentTab === 2">
          {{ $t("CustomMessageConfiguration") }}
        </div>
        <div v-else-if="currentTab === 3">{{ $t("CustomMessagePreview") }}</div>
        <div>
          <v-btn
            @click="updateParentTabPrev"
            class="previousBtn"
            v-if="currentTab !== 0 && currentTab !== 3"
            >Previous</v-btn
          >
          <v-btn
            @click="updateParentTabNext"
            class="nextBtn"
            v-if="currentTab !== 3"
            >Next</v-btn
          >
          <v-btn class="nextBtn" v-if="currentTab === 3" @click="executeHandler">Execute</v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { bus } from "@/main.js";
import { mapActions } from "vuex";
export default {
  name: "Tabs",

  props: {
    tabs: {
      type: Array,
      required: true,
    },
    currentTab: {
      type: Number,
      required: true,
    },
  },
  methods: {
    ...mapActions(["clearWorkspace", "clearWorkspaceGeometry", "clearBuildings", "clearSimulationConfiguration", "clearPercentage","CREATE_SIMULATION_CONFIG", "CREATE_SIMULATION"]),
    updateParentTab(newValue) {
      this.$emit("update-current-tab", newValue);
    },
    updateParentTabNext() {
      const newValue = this.currentTab + 1;
      this.$emit("update-current-tab", newValue);
      if(this.currentTab === 2) {
        bus.$emit("set-form-data-in-vuex")
      }
    },
    updateParentTabPrev() {
      const newValue = this.currentTab - 1;
      this.$emit("update-current-tab", newValue);
    },
    getWorkspace(){
      let id;
      if(this.$store.getters.getWorkspace){
        id = this.$store.getters.getWorkspace.wp_id
      }else{
        id = this.$store.getters.getProvisionalWorkspace
      }
      return id;
    },
    getPercentages(){
      const filterPercentages =  [];
      this.$store.getters.getPercentages.map(item => {
        if(item){
          filterPercentages.push(item);
        }
      });
      return filterPercentages;
    },
    getTextGeom(){
      let textGeom;
      if(this.$store.getters.getWorkspace){
        textGeom = this.$store.getters.getWorkspace.wp_text_geom
      }else{
        textGeom = this.$store.getters.getWorkspaceGeometry
      }
      return textGeom;
    }
  },
};
</script>
<style scoped>
.text-left {
  text-align: left;
  padding: 20px 0px;
}
.custom-tab {
  text-transform: none !important;
}

.textContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.previousBtn {
  border-radius: 8px;
  border: 1px solid #67a0b4;
  background-color: #fff !important;
  color: #67a0b4;
  margin-right: 16px;
  box-shadow: none !important;
}
.nextBtn {
  border-radius: 8px;
  background: #67a0b4 !important;
  color: #fff;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/Tabs.vue